import { useCallback, useMemo } from 'react'
import { Trans } from '@lingui/react/macro'
import { dateTime, NaiveDateTime, TimeUnits } from '@guestgoodie/helpers'

import Dropdown from '@/components/ui/Dropdown'
import DateTimeInput from '@/components/ui/DateTimeInput'
import { EndType } from '../types'
import { useEndOptions } from '../utils/helpers'

export function EndSelect({
  value,
  onChange
}: {
  value: NaiveDateTime | null
  onChange: (until: NaiveDateTime | null) => void
}) {
  const endOptions = useEndOptions()

  const endType = useMemo(() => {
    if (value) return EndType.until
    return EndType.never
  }, [value])

  const onChangeEndType = useCallback(
    (endType: EndType) => {
      if (endType === EndType.never) onChange(null)

      if (endType === EndType.until) {
        const aYearFromNow = dateTime.hotelDateNow().add(1, TimeUnits.YEAR)

        onChange(aYearFromNow)
      }
    },
    [onChange]
  )

  return (
    <label className="flex flex-row items-center gap-2">
      <span>
        <Trans>Ending</Trans>:
      </span>
      <div>
        <Dropdown<EndType>
          options={endOptions}
          value={endType}
          onChange={onChangeEndType}
        />
      </div>
      {endType === EndType.until && (
        <DateTimeInput value={value ?? undefined} onChange={onChange} />
      )}
    </label>
  )
}
